import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
// import Home from "../src/Home"
import { useEffect, useState, useRef } from "react";
import Navbar from "../src/Global/Navbar";
import Head from "../src/Global/Header_for_mobile";
import Footer from "../src/Global/Footer";
import Foot from "../src/Global/Footer_for_mobile";
import IndexPage from "./HomePage/indexPage";
import Index from "../src/Home";
import IndexListPage from "./Listpage/IndexListPage";
import CabDetails from "./Home/CabDetails";
import IndexSeats from "./Seats/IndexSeats";
import Card from "./Home/Card";
import IndexBooking from "./BookingConfirmation/indexBooking";
import IndexUser from "./UserProfile/IndexUser";
import Signin from "./Register/Signin";
import Signup from "./Register/Signup";
import TermsandCondition from "./UserProfile/TermsandCondition";
import IndexFull from "./FullCars/IndexFull";
import IndexFullcab from "./FullCabBooking/IndexFullcab";
import FullCarBookingConfirmed from "./FullCabBooking/FullCarBookingConfirmed";
import IndexHomemobile from "./HomeMobile/IndexHomemobile";
import IndexHotel from "./Hotel/IndexHotel";
import { FaWhatsapp, FaPhoneAlt, FaChevronUp, FaTimes } from "react-icons/fa";
import { TbSos } from "react-icons/tb";
import IndexPackages from "./packages/IndexPackages";
import Detailedbooking from "./UserProfile/booking";
import Aboutus from "./Global/aboutus";
import Fullcabbook from "./Seats/fullcabseats";
import CareersPage from "./Careers/careers";
import JobDetails from "./Careers/jobDetails";
import JobApplyForm from "./Careers/applyForm";
import RequestPermission from "../src/Shared/requestPermission";
import NotificationInit from "../src/Shared/NotificationInit";
import { IndexOffers } from "./packages/IndexPackages";
import { useSelector } from "react-redux";
import CorporateBookings from "./Home/corporateBookings";
import InstallInstructions from "./Home/InstallInstructions";
import Tours from "./packages/Tours"
import TourDetails from "./packages/TourDetail"
import ContactUs from "./Global/contactus";
//import {RelaxationPackage} from "./RelaxationPackage/relaxationPackage"
import AppJS from "./RelaxationPackage/AppJS"
import PartnerWithUs from "./PartnerWithUs/partnerWithUs";
import WellnessInfoPage from "./RelaxationPackage/wellnessinfopage";
import WellnessDetail from "./RelaxationPackage/WellnessDetail";
import IndexVendor from "./VendorPortal/Index";
import VendorLogin from "./VendorPortal/vendorLogin";
import VendorRegister from "./VendorPortal/vendorRegister";
import VendorPrivateRoute from "./VendorPortal/VendorPrivateRoute";
import { MyProperties } from "./VendorPortal/MyProperties";
import { PropertyDetailPageWrapper } from "./VendorPortal/PropertyDetailPageWrapper";
import { PropertyEditPageWrapper } from "./VendorPortal/PropertyEditPageWrapper";
import PropertyList from "./Hotel/PropertyList";
import { PropertyDetail } from "./Hotel/PropertyDetail";
import HotelBookingInvoice from "./Hotel/HotelBookingInvoice";
import HotelInvoicePDF from "./Hotel/HotelInvoicePdf";
import VendorProfile from "./VendorPortal/VendorProfile";
import TourBookingInvoice from "./packages/TourBookingInvoice";
import WellnessBookingInvoice from "./RelaxationPackage/WellnessBookingInvoice";
import ResetPassword from "./VendorPortal/ResetPassword";
import TourBookingDetail from "./UserProfile/TourBookingDetail";
import HotelBookingDetail from "./UserProfile/HotelBookingDetail";
import WellnessBookingDetail from "./UserProfile/WellnessBookingDetail";
import ChatSuccess from "../src/Pages/ChatSuccess";
import ChatbotPage from "./Chatbot";
import PaymentSuccess from "../src/Pages/PaymentSuccess"
import BecomeCoach from "../src/Coach/BecomeCoach"
//import VendorBookingsCalendar from "./VendorPortal/VendorBookingsCalendar";
import RetreatCalendarPage from "./RelaxationPackage/RetreatCalendarPage";
import usePageTracking from "./hooks/usePageTracking";
import ScrollToTop from "./Global/ScrollToTop";
import CashfreePaymentStatus from "./Pages/CashfreePaymentStatus";
import HotelCashfreePaymentStatus from "./Pages/HotelCashfreePaymentStatus";
import CashfreePaymentStatusRide from "./Pages/CashfreePaymentStatusRide";
import CashfreePaymentStatusTour from "./Pages/CashfreePaymentStatusTour";
import FloatingChatbot from "./Chatbot/floating"
import { initMetaPixel, trackEvent } from "./utils/metaPixel";

export default function App() {

  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
   const [isFixed, setIsFixed] = useState(true);

  const { token, user, isAuthenticate } = useSelector(
    (state) => state.userauth
  );
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

       const handleScroll = () => {
        const mobile = window.innerWidth <= 768;
      if (mobile) {
        // Mobile â†’ Always fixed
        setIsFixed(true);
      } else {
        // Desktop â†’ Fixed only for first 2 viewport heights
        const scrollLimit = window.innerHeight * 2; // 2 pages
        if (window.scrollY <= scrollLimit) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }
      }
    };

    window.addEventListener("resize", handleResize);
 window.addEventListener("scroll", handleScroll);

 handleScroll();

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
 

  // useEffect(() => {
  //   const registerServiceWorker = async () => {
  //     if ("serviceWorker" in navigator) {
  //       try {
  //         const registration = await navigator.serviceWorker.register(
  //           "/sw.js",
  //           { scope: "/" }
  //         );
  //         console.log(
  //           registration.installing
  //             ? "Service worker installing"
  //             : registration.waiting
  //             ? "Service worker installed"
  //             : "Service worker active"
  //         );
  //       } catch (error) {
  //         console.error(`Registration failed with ${error}`);
  //       }
  //     }
  //   };
  //   registerServiceWorker();
  // }, []);

    // Determine if header/footer should be shown
      const searchParams = new URLSearchParams(location.search);
  // Embedded = ?embed=true OR running inside an iframe (chatbot split-view).
  // Keeps header/footer hidden after in-iframe navigation drops ?embed=true.
  const isInIframe = (() => {
    try { return window.self !== window.top; } catch (e) { return true; }
  })();
  const isEmbedded = searchParams.get("embed") === "true" || isInIframe;

 const hideHeaderFooter =
  isEmbedded ||
  location.pathname === "/vendorportal" ||
  location.pathname.startsWith("/property/") ||
  location.pathname.startsWith("/property/edit/");

  
  usePageTracking();

   

   useEffect(() => {
     if (window.fbq) window.fbq("track", "PageView");
   }, [location.pathname]);
   
   

  // Embedded preview: pages reserve space at the top for the (now hidden) navbar.
  // Walk down the top of the page and strip big spacer divs / top padding / top margin.
  useEffect(() => {
    if (!isEmbedded) return;
    const LIMIT = 40; // px — anything bigger at the very top is treated as navbar offset
    const strip = () => {
      const root = document.querySelector(".tgh-embed-root > .flex-grow");
      let el = root ? root.firstElementChild : null;
      for (let depth = 0; el && depth < 10; depth++) {
        const cs = window.getComputedStyle(el);
        const isSpacer = !el.children.length && !el.textContent.trim() && el.tagName !== "IMG" && parseFloat(cs.height) > LIMIT;
        if (isSpacer) {
          el.style.setProperty("display", "none", "important");
          el = el.nextElementSibling;
          continue;
        }
        if (parseFloat(cs.paddingTop) > LIMIT) el.style.setProperty("padding-top", "0", "important");
        if (parseFloat(cs.marginTop) > LIMIT) el.style.setProperty("margin-top", "0", "important");
        if (cs.position === "relative" && parseFloat(cs.top) > LIMIT) el.style.setProperty("top", "0", "important");
        el = el.firstElementChild;
      }
    };
    strip();
    const observer = new MutationObserver(strip); // pages render after their data loads
    observer.observe(document.body, { childList: true, subtree: true });
    const stop = setTimeout(() => observer.disconnect(), 6000);
    return () => { observer.disconnect(); clearTimeout(stop); };
  }, [isEmbedded, location.pathname]);

  const WhatsAppButton = () => {
  const containerRef = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  const phoneNumber = "+919883587965";

  const handleMouseDown = (e) => {
    setIsDragging(true);
    const rect = containerRef.current.getBoundingClientRect();
    containerRef.current.offset = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const x = e.clientX - containerRef.current.offset.x;
    const y = e.clientY - containerRef.current.offset.y;
    setPosition({ x, y });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging]);

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        left: position.x || "auto",
        top: position.y || "auto",
        bottom: position.y === 0 ? "9rem" : "auto",
        right: position.x === 0 ? "1.25rem" : "auto",
        zIndex: 9999,
      }}
      className="flex flex-col items-end gap-3"
    >
      {/* WhatsApp - shown only when open */}
      
      <a href={`https://wa.me/${phoneNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        title="WhatsApp"
        className={`bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 ease-out
          ${isOpen ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-4 scale-0 pointer-events-none"}
        `}
      >
        <FaWhatsapp size={20} />
      </a>

      {/* Phone - shown only when open */}
      
        <a href={`tel:${phoneNumber}`}
        title="Call"
        className={`bg-blue-500 text-white p-3 rounded-full shadow-lg hover:bg-blue-600 transition-all duration-300 ease-out
          ${isOpen ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-4 scale-0 pointer-events-none"}
        `}
      >
        <FaPhoneAlt size={20} />
      </a>

   {/* Main toggle button - only this is draggable */}
<button
  onMouseDown={handleMouseDown}
  onClick={() => setIsOpen((prev) => !prev)}
  title={isOpen ? "Close" : "More"}
  style={{ cursor: "grab" }}
  className="bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 flex flex-col items-center justify-center w-12 h-12"
>
  {isOpen ? (
    <FaTimes size={18} />
  ) : (
    <>
      <FaChevronUp size={14} />
      <span className="text-[10px] leading-none mt-0.5">More</span>
    </>
  )}
</button>
    </div>
  );
};
  return (
    <>
      <ScrollToTop />
      {isEmbedded && (
        <style>{`
          /* Embedded preview (chatbot split-view): navbar is hidden, so remove the
             top spacing pages reserve for it. */
          .tgh-embed-root > .flex-grow { padding-top: 0 !important; margin-top: 0 !important; }
          .tgh-embed-root > .flex-grow > *:first-child { margin-top: 0 !important; padding-top: 0 !important; }
          .tgh-embed-root > .flex-grow > *:first-child > *:first-child { margin-top: 0 !important; }
        `}</style>
      )}
      <div className={`flex flex-col min-h-screen ${isEmbedded ? "tgh-embed-root" : ""}`}>
         {!hideHeaderFooter && (
        <div className={`w-full ${
          isFixed
            ? "fixed top-0 left-0 z-50 bg-white shadow-md"
            : "relative bg-white"
        }`}>
          {isMobile ? <Head /> : <Navbar />}
        </div>
      )}

      <div className={`flex-grow`}>
          <Routes>
            {/* <Route path="/" element={<IndexHomemobile />} /> */}
            <Route path="/" element={<IndexPage/>} />
            <Route path="/bookCabs" element={<Index />} />
            <Route path="/sharedcabs" element={<IndexListPage />} />
            <Route path="/Seats/:vid" element={<IndexSeats />} />
            <Route path="/packages" element={<IndexPackages />} />
            <Route
              path="/sharedcabbookingconfirmed"
              element={<IndexBooking />}
            />
            <Route path="/userprofile" element={<IndexUser />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsandCondition />}
            />
            <Route path="/fullcars" element={<IndexFull />} />
            <Route path="/fullcabbooking" element={<IndexFullcab />} />
            <Route path="/fullcabbook/:id" element={<Fullcabbook />} />
            <Route path="/detailedbooking" element={<Detailedbooking />} />
            <Route path="/aboutus" element={<Aboutus />} />
            <Route
              path="/fullcabbookingconfirmed"
              element={<FullCarBookingConfirmed />}
            />
            <Route path="/home" element={<IndexHomemobile />} />
            <Route path="/hotels" element={<IndexHotel />} /> 
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/job-details/:id" element={<JobDetails />} />
            <Route path="/careers/apply/:id" element={<JobApplyForm />} />
            <Route path="/corporate-bookings" element={<CorporateBookings />} />
            <Route path="/install" element={<InstallInstructions />} />
             <Route path="/tours" element={<Tours/>} />
               <Route path="/tours/:id" element={<TourDetails/>} />
               <Route path="/contactus" element={<ContactUs/>} />
                    {/*<Route path="/relaxationpackage" element={<RelaxationPackage/>} /> */}
               <Route path="/wellness" element={<AppJS/>} />
               <Route path="/wellness/:id" element={<WellnessDetail/>} />
                <Route path="/partnerwithus" element={<PartnerWithUs/>} />
                <Route path="/wellnessinfopage" element={<WellnessInfoPage/>} />
<Route
  path="/vendorportal"
  element={
    <VendorPrivateRoute>
      <IndexVendor />
    </VendorPrivateRoute>
  }
/>

<Route path="/vendor/login" element={<VendorLogin onLoginSuccess={() => {
  window.location.href = '/vendorportal';
}} />} />
<Route path="/vendor/register" element={<VendorRegister />} />
<Route path="/my-properties" element={<MyProperties />} />
<Route path="/property/:propertyId" element={<PropertyDetailPageWrapper />} />
<Route path="/property/edit/:propertyId" element={<PropertyEditPageWrapper />} />
 <Route path="/hotel-invoice" element={<HotelBookingInvoice />} />
 <Route path="/vendor/profile" element={<VendorProfile />} />
 <Route path="/tour-invoice" element={<TourBookingInvoice />} />
 <Route path="/wellness-invoice" element={<WellnessBookingInvoice />} />
<Route path="/vendor/reset-password" element={<ResetPassword />} />
<Route path="/hotel/property/:propertyId" element={<PropertyDetail />} />
<Route 
  path="/tour-booking/:id" 
  element={<TourBookingDetail />} 
/>
<Route 
  path="/hotel-booking/:id" 
  element={<HotelBookingDetail />} 
/>
<Route 
  path="/wellness-booking/:id" 
  element={<WellnessBookingDetail />} 
/>

 <Route path="/chat-success" element={<ChatSuccess />} />
           <Route path="/chatbot" element={<ChatbotPage />} />
           <Route path="/payment-success" element={<PaymentSuccess />} />
 <Route path="/become-coach" element={<BecomeCoach />} />    
  <Route path="/retreat-calendar" element={<RetreatCalendarPage />} />      
  <Route
  path="/cashfree-payment-status"
  element={<CashfreePaymentStatus />}
/>
<Route path="/hotel-cashfree-payment-status" element={<HotelCashfreePaymentStatus />} />
<Route path="/cashfree-payment-status-ride" element={<CashfreePaymentStatusRide />} />
<Route path="/cashfree-payment-status-tour" element={<CashfreePaymentStatusTour />} />
          </Routes>
        
        </div>
             {!hideHeaderFooter && (isMobile ? <Foot /> : <Footer />)}
        {!isEmbedded && <WhatsAppButton />}
        {!isEmbedded && <FloatingChatbot />}
        <div><NotificationInit /></div>
      </div>
    </>
  );
}